import {GetterTree, MutationTree, ActionTree} from 'vuex'
import {CommentsState} from '@/store/types'
import axios from 'axios'

type CommentsGetter = GetterTree<CommentsState, any>
type CommentsMutation = MutationTree<CommentsState>
type CommentsAction = ActionTree<CommentsState, any>

const state: CommentsState = {
  comments: [],
}

const getters: CommentsGetter = {
  comments: (state) => state.comments,
}

const mutations: CommentsMutation = {
  setComments: (state, comments) => {
    state.comments = comments
  },
  addComment: (state, comment) => {
    state.comments.push(Object.assign({}, comment))
  },
}

const actions: CommentsAction = {
  addComment: ({commit}, payload) => {
    return new Promise((resolve, reject) => {
      axios.post('comments', payload).then((response) => {
        commit('addComment', response.data.data)
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
